import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MdWorkOutline } from 'react-icons/md';
import { BiWorld } from 'react-icons/bi';

import JobCards from '../component/JobCards';
import './MainPage.css';

function MainPage() {

    const [query, setQuery] = useState("");
    const [location, setLocation] = useState("");

    const [fullTime, setFullTime] = useState(false);

    const [apiData, setApiData] = useState([]);

    const [error, setError] = useState(null);

    const [loading, setLoading] = useState(true);

    const [pagination, setPagination] = useState(0);


  

    const fetchJobs = (jobQuery, jobLocation) => {

        setLoading(true);
        setError(null);

        const options = {

            method: "GET",

            url: "https://jsearch.p.rapidapi.com/search-v2",

            params: {

                query:
                    `${jobQuery || "developer jobs"} in ${jobLocation || "chicago"}`,

                num_pages: "1",

                country: "us",

                date_posted: "all"

            },

            headers: {

                "Content-Type": "application/json",

                "x-rapidapi-host":
                    "jsearch.p.rapidapi.com",

                "x-rapidapi-key":
                    "84c249f594msh9bfd20978d6fe14p19f4f5jsn2fba10eab3d7"

            }

        };


        axios
            .request(options)

            .then((response) => {

                console.log("API RESPONSE:", response.data);

                setApiData(response.data.data || []);

                setLoading(false);

            })

            .catch((err) => {

                console.log("API ERROR:", err);

                setError(err);

                setApiData([]);

                setLoading(false);

            });

    };


    // ================= SEARCH =================

    const handleSubmit = (e) => {

        e.preventDefault();

        setPagination(0);

        fetchJobs(query, location);

    };


    // ================= FIRST LOAD =================

    useEffect(() => {

        fetchJobs("", "");

    }, []);


    return (

        <div className="main-wrapper">


            {/* ================= TITLE ================= */}

            <div className="logo-title">

                <b>PSK JOB Portal</b>

            </div>


            {/* ================= ERROR ================= */}

            {error && (

                <div className="error-box">

                    <div className="error-title">

                        {error.code || "API Error"}

                    </div>

                    <div>

                        {error.response?.data?.message ||
                            "Unable to fetch jobs from API."}

                    </div>

                </div>

            )}


            {/* ================= SEARCH ================= */}

            <header className="header-box">

                <form
                    className="search-box"
                    onSubmit={handleSubmit}
                >


                    <MdWorkOutline
                        className="search-icon"
                    />


                    <input
                        type="text"
                        value={query}
                        onChange={(e) =>
                            setQuery(e.target.value)
                        }
                        placeholder="Job Title, Company, or skills"
                        className="search-input"
                    />


                    <button
                        type="submit"
                        className="search-btn"
                    >

                        Search

                    </button>


                </form>

            </header>


            {/* ================= MAIN CONTENT ================= */}

            <main className="main-content">


                {/* ================= FILTER ================= */}

                <form
                    className="filter-box"
                    onSubmit={(e) =>
                        e.preventDefault()
                    }
                >


                    {/* FULL TIME */}

                    <label>

                        <input
                            type="checkbox"
                            checked={fullTime}
                            onChange={(e) => {

                                setFullTime(
                                    e.target.checked
                                );

                            }}
                            className="checkbox"
                        />

                        Full Time

                    </label>


                    {/* LOCATION TITLE */}

                    <label className="filter-title">

                        Location

                    </label>


                    {/* LOCATION INPUT */}

                    <div className="location-input-box">

                        <BiWorld />

                        <input
                            type="text"
                            value={location}
                            onChange={(e) =>
                                setLocation(e.target.value)
                            }
                            placeholder="city,state,country"
                            className="location-input"
                        />

                    </div>


                    {/* LOCATION OPTIONS */}

                    <div className="radio-container">

                        {[
                            "India",
                            "London",
                            "New York"
                        ].map((city) => (

                            <label key={city}>

                                <input
                                    type="radio"
                                    name="location"
                                    value={city}
                                    checked={
                                        location === city
                                    }
                                    onChange={() => {

                                        setLocation(city);

                                        fetchJobs(
                                            query,
                                            city
                                        );

                                    }}
                                    className="radio"
                                />

                                {city}

                            </label>

                        ))}

                    </div>


                </form>


                {/* ================= JOB RESULTS ================= */}

                <section className="result-section">


                    {loading ? (

                        <div className="loading-box">

                            <h3>
                                Loading Jobs...
                            </h3>

                        </div>

                    ) : apiData.length > 0 ? (

                        <JobCards
                            apiData={apiData}
                            pagination={pagination}
                        />

                    ) : (

                        <div className="loading-box">

                            <h3>
                                No Jobs Found
                            </h3>

                        </div>

                    )}


                </section>


            </main>


        </div>

    );

}

export default MainPage;